/* eslint-disable no-restricted-syntax */

import Immutable from 'immutable';
import {
  CREATE_GROUP,
  UPDATE_GROUP,
  SET_GROUPS,
  REMOVE_GROUP,
  UPDATE_GROUP_ADMIN_ACCESS,
} from './actions';

import { PORTFOLIO_QUERY_COMPLETE } from '../Galleries/actions';

export function Groups(state = Immutable.Map(), action) {
  switch (action.type) {
    case UPDATE_GROUP: {
      const { path, changes } = action;
      return state.updateIn([path], Immutable.Map(), (g) =>
        g.merge(Immutable.fromJS(changes))
      );
    }
    case CREATE_GROUP: {
      const { group } = action;
      return state.set(group.get('path'), group);
    }
    case PORTFOLIO_QUERY_COMPLETE:
    case SET_GROUPS: {
      let newState = state;
      const { groups } = action;
      for (const group of groups.values()) {
        newState = newState.updateIn(
          [group.get('path')],
          Immutable.Map(),
          (g) => g.merge(group)
        );
      }
      return newState;
    }
    case UPDATE_GROUP_ADMIN_ACCESS: {
      const { path, userId, isAdmin } = action;

      return state.updateIn([path, 'members'], (members) => {
        return members.map((member) => {
          return member.get('user') === userId
            ? member.set('admin', isAdmin)
            : member;
        });
      });
    }
    case REMOVE_GROUP: {
      return state.delete(action.path);
    }

    default: {
      return state;
    }
  }
}
